import { z } from 'zod';
import { VendorStatus } from '../../constants/vendor-status.js';
import { nonNegativeInt, nonNegativeNumber, optionalPresentUuidString, optionalUuidString, optionalTrimmedNullableEmail, optionalTrimmedNullableString, rejectPhoneContextInjection, } from '../zod-helpers/index.js';
import { VENDOR_CONSTRAINTS } from './constraints.js';
export const updateVendorInputSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, 'Vendor name cannot be empty.')
        .max(VENDOR_CONSTRAINTS.name.maxLength)
        .optional(),
    url: z.string().max(VENDOR_CONSTRAINTS.url.maxLength).optional().nullable(),
    email: optionalTrimmedNullableEmail(VENDOR_CONSTRAINTS.email.maxLength, `Invalid ${VENDOR_CONSTRAINTS.email.label.toLowerCase()}.`),
    phone: rejectPhoneContextInjection(optionalTrimmedNullableString(VENDOR_CONSTRAINTS.phone.maxLength)),
    note: optionalTrimmedNullableString(VENDOR_CONSTRAINTS.note.maxLength),
    currencyId: optionalUuidString('Invalid currency selection.').optional().nullable(),
    paymentTermsId: optionalPresentUuidString('Invalid payment terms selection.').optional(),
    shipTermsId: optionalPresentUuidString('Invalid ship terms selection.').optional(),
    carrierId: optionalPresentUuidString('Invalid carrier selection.').optional(),
    creditLimit: nonNegativeNumber(VENDOR_CONSTRAINTS.creditLimit.label).optional().nullable(),
    leadTime: nonNegativeInt(VENDOR_CONSTRAINTS.leadTime.label).optional().nullable(),
    minOrderAmount: nonNegativeNumber(VENDOR_CONSTRAINTS.minOrderAmount.label).optional().nullable(),
    statusId: z.enum(VendorStatus, 'Invalid vendor status.').optional().nullable(),
});
//# sourceMappingURL=update-input.js.map